import ReactQuill from 'react-quill';
import DirectInput from '../../directInput/DirectInput';
import { modules } from '../../../utils/quillModules';
import { formats } from '../../../utils/quillFormats';
import DropdownReg from '../../dropdownReg/DropdownReg';
import { forwardRef } from 'react';
import useSectionHighlightRef from '../../../hooks/useSectionHighlightRef';
import CharCount from '../../charCount/CharCount';

const Basic = forwardRef(({ packData, setPackData, isEdit }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const group_options = ['backpacking', 'vehicle'];
    const dateType_options = ['fixed', 'custom'];
    return (
        <div ref={sectionRef}>
            {isEdit ? (
                <h1 className='orgPackUpH1'>Edit Package</h1>
            ) : (
                <h1 className='orgPackUpH1'>Create New Package</h1>
            )}
            <DropdownReg
                label='Group'
                name={'group'}
                options={group_options}
                value={packData?.group}
                req={true}
                setFormData={setPackData}
                error={highlightField === 'group'}
            />
            <DropdownReg
                label='Date Types'
                name={'datesType'}
                options={dateType_options}
                value={packData?.datesType}
                req={true}
                setFormData={setPackData}
                error={highlightField === 'datesType'}
            />
            <div className='orgPackUpSecDiv'>
                <DirectInput
                    label='Title'
                    name='title'
                    value={packData?.title}
                    type='text'
                    placeholder='Title'
                    setFormData={setPackData}
                    min={3}
                    limit={50}
                    error={highlightField === 'title'}
                />
                {/* <Textarea
                    label='Overview'
                    name='overview'
                    value={packData.overview}
                    placeholder='Overview'
                    setFormData={setPackData}
                    min={50}
                    limit={4000}
                    disabled={isEdit && packData.status !== 'inactive' && packData.status !== 'rejected'}
                /> */}
                <div className='itineraryDiv'>
                    <label className='itineraryLabel'>Overview</label>
                    <div className='itineraryDescDiv'>
                        <ReactQuill
                            name='overview'
                            value={packData?.overview}
                            onChange={(e) =>
                                setPackData((prevState) => {
                                    return { ...prevState, overview: e };
                                })
                            }
                            theme='snow'
                            placeholder='Overview'
                            className={`${highlightField === 'overview' ? 'error-highlight' : ''}`}
                            readOnly={isEdit && packData?.status !== 'inactive' && packData?.status !== 'rejected'}
                            modules={modules}
                            formats={formats}
                        />
                        <CharCount string={packData?.overview} min={50} limit={4000} />
                    </div>
                </div>
                {/* //example -  For weekend trip which starts at friday night and
    //return on sunday or monday morning is two days. */}
                <DirectInput
                    label='Days'
                    name='days'
                    value={packData?.days}
                    type='number'
                    placeholder='days'
                    setFormData={setPackData}
                    min={1}
                    limit={2}
                    error={highlightField === 'days'}
                />
                <DirectInput
                    label='Nights'
                    name='nights'
                    value={packData?.nights}
                    type='number'
                    placeholder='nights'
                    setFormData={setPackData}
                    min={1}
                    limit={2}
                    error={highlightField === 'nights'}
                />
            </div>
        </div>
    );
});

export default Basic;
